const notes = document.querySelectorAll('.orla-field-note');

const observer = new IntersectionObserver(
	(entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('visible');
				observer.unobserve(entry.target); // optional: trigger once
			}
		});
	},
	{
		root: null,
		threshold: 0,
		rootMargin: '0px 0px -30% 0px',
	}
);

notes.forEach((note) => observer.observe(note));
